export default "__VITE_ASSET__CGePS66B__"